import type { MutationConfig } from "apps/visits/core/lib/react-query";
import type { AxiosError } from "axios";
import { useMutation } from "react-query";
import type { Order } from "../models";
import { useGetSlug } from "../store/use-config";
import { GroupActionsOrderingRepository } from "./group-actions-ordering.api";
import type { ConfirmOrderErrorResponse } from "./group-actions-ordering.types";

const groupActionsOrderingRepository = new GroupActionsOrderingRepository();

type UseConfirmOrderOptions = {
  uuid: Order["uuid"];
  config?: MutationConfig<typeof groupActionsOrderingRepository.confirmOrder, AxiosError<ConfirmOrderErrorResponse>>;
};

export const useConfirmOrder = ({ uuid, config }: UseConfirmOrderOptions) => {
  const slug = useGetSlug();

  return useMutation({
    ...config,
    mutationFn: () => groupActionsOrderingRepository.confirmOrder(uuid, slug),
  });
};
